import { render, staticRenderFns } from "./achangeKefu.vue?vue&type=template&id=432e6293&scoped=true&"
import script from "./achangeKefu.vue?vue&type=script&lang=js&"
export * from "./achangeKefu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432e6293",
  null
  
)

export default component.exports